export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0/static/v4/common/icon-loading-99670860d2010d72b626a578b6ffebfe.png";